import { IOrganization } from '../../../../../../models/partnerportalen/organization.model';

export class OrganizationAdministratorApiModel {
  id!: number;
  organizationNumber!: string;
  name!: string;
  contactName!: string;
  email!: string;
  streetAddress!: string;
  postalCode!: string;
  city!: string;
  phoneNumber!: string;
  numberOfCopies!: number;

  static mapToBusinessModel(apiModel: OrganizationAdministratorApiModel): IOrganization {
    return {
      id: apiModel.id,
      organizationNumber: apiModel.organizationNumber,
      name: apiModel.name,
      contactName: apiModel.contactName,
      email: apiModel.email,
      address: apiModel.streetAddress,
      postalCode: apiModel.postalCode,
      city: apiModel.city,
      phoneNumber: apiModel.phoneNumber,
      numberOfCopies: apiModel.numberOfCopies,
      isConsentGiven: false, // Not available in administrator model
    };
  }
}
